import YetiClient from "./YetiClient";

const YetiContacts = {
  employee_list: async function () {
    const config = {
      params: {
        cache: "1",
      }
    };
    return YetiClient.get('/contacts/employeelist',config);
  },
  contact_list: async function () {
    const config = {
      params: {
        cache: "1",
        include_authorized: "1",
        status: "ACTIVE",
      }
    };
    return YetiClient.get('/contacts/contactlist',config);
  }
};

export default YetiContacts;
